// extracted by mini-css-extract-plugin
export var contentPlacement = "TreatmentList-module--contentPlacement--e2c09";
export var kickerLineHeight = "TreatmentList-module--kickerLineHeight--3356e";
export var navContainer = "TreatmentList-module--navContainer--fc13d";
export var sectionContainer = "TreatmentList-module--sectionContainer--f557a";
export var titleClassName = "TreatmentList-module--titleClassName--4ae0e";
export var treatmentItem = "TreatmentList-module--treatmentItem--faa1e";
export var treatmentNav = "TreatmentList-module--treatmentNav--df4f0";
export var treatments = "TreatmentList-module--treatments--8e422";
export var treatmentsContainer = "TreatmentList-module--treatmentsContainer--df597";
export var treatmentsImage = "TreatmentList-module--treatmentsImage--87c53";
export var treatmentsList = "TreatmentList-module--treatmentsList--ab69a";